var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMaillists = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8C4 6.89543 4.89543 6 6 6H18C19.1046 6 20 6.89543 20 8V8.3L13.2251 13.5505C12.504 14.1094 11.496 14.1094 10.7749 13.5505L4 8.3V8ZM5.9 8H18.1L12 12.7L5.9 8Z",
    fill: "#767676",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.8L4 9.3V16C4 17.1046 4.89543 18 6 18H18C19.1046 18 20 17.1046 20 16V9.30001L18 10.8V16H6V10.8Z",
    fill: "#767676",
    fillOpacity: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMaillists);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/maillists.74a78cc0e6d4d6a92cc2d02eeaa9d8cd.svg";